import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin( ScrollTrigger );

function wrap ( value, min, max ) {
    const v = value - min;
    const r = max - min;

    return ( ( r + v % r ) % r ) + min + "px";
}

export const initCarousel = () => {
    const blocks = document.querySelectorAll( '.wp-block-drsblocks-runph' )
    if ( !blocks.length ) return

    blocks.forEach( ( block ) => {
        const container = block.querySelector( '.wp-block-drsblocks-runph__inner' ),
            text = block.querySelector( '.wp-block-drsblocks-runph__text' ),
            windowWidth = window.innerWidth,
            textWidth = text.offsetWidth,
            textHeight = text.offsetHeight
        gsap.set( block, { height: textHeight } )

        const n = windowWidth / textWidth

        for ( let i = 0; i < n; i++ ) {
            const innerClone = text.cloneNode( true )
            container.append( innerClone )
        }
        const newTexts = container.querySelectorAll( '.wp-block-drsblocks-runph__text' )
        const wrapWidth = newTexts.length * textWidth;

        gsap.set( newTexts, {
            x ( i ) {
                return i * textWidth;
            }
        } )

        animateCarousel()
        function animateCarousel () {
            gsap.to( newTexts, {
                duration: 70,
                ease: "none",
                // force3D: false,
                x ( i, target ) {
                    const x = gsap.getProperty( target, "x" ) - wrapWidth
                    return x;
                },
                modifiers: {
                    x ( x ) {
                        return wrap( parseInt( x ), -textWidth, ( newTexts.length - 1 ) * textWidth )
                    }
                },
                repeat: -1
            } );
        }

    } )
}

document.addEventListener( 'DOMContentLoaded', () => {
    initCarousel()
} )